module.exports = __webpack_public_path__ + "static/img/ps.b7495d8b.svg";